import { IconAlarm } from '@assets/images/main/index';
import {
  CameraFunctions1D,
  CameraFunctions1M,
  CameraFunctions1T,
  CameraFunctions2D,
  CameraFunctions2M,
  CameraFunctions2T,
  CameraFunctions3D,
  CameraFunctions3M,
  CameraFunctions3T,
  CameraFunctions4D,
  CameraFunctions4M,
  CameraFunctions4T,
  CameraFunctions5D,
  CameraFunctions5M,
  CameraFunctions5T,
  CameraFunctions6D,
  CameraFunctions6M,
  CameraFunctions6T,
  CameraFunctions7D,
  CameraFunctions7M,
  CameraFunctions7T,
} from '@assets/images/main/camera/main/functions';
import { IconAiServerInv, IconEdgeAiInv, IconEdgeOff, IconEdgeOn, IconOsOff, IconOsOn, IconServerOff, IconServerOn } from '@assets/images/main/icon';
import {
  cameraBannerBg,
  cameraBannerProduct,
  cameraScreenshot1D,
  cameraScreenshot1M,
  cameraScreenshot1T,
  cameraScreenshot2D,
  cameraScreenshot2M,
  cameraScreenshot2T,
  cameraScreenshot3D,
  cameraScreenshot3M,
  cameraScreenshot3T,
} from '@assets/images/main/camera';
import { IconBlueCircle, IconBlueShield } from '@assets/images/main/icon/blue';
import { Icon3d3d, Icon3dCycle, Icon3dDetect, Icon3dMeter } from '@assets/images/icon';
import { screenViewCamera1, screenViewCamera2, screenViewCamera3, screenViewCamera4, screenViewCamera5 } from '@assets/images/main/screenView';

import { ReactComponent as SvgGridLine } from '@assets/images/icon/svg/grid-line.svg';
import { ReactComponent as SvgLocationLine } from '@assets/images/icon/svg/location-line.svg';
import { ReactComponent as SvgChartLine } from '@assets/images/icon/svg/chart-line.svg';
import { ReactComponent as SvgPencilLine } from '@assets/images/icon/svg/pencil-line.svg';
import { ReactComponent as SvgAi } from '@assets/images/icon/svg/ai.svg';

export default {
  mainPage: {
    product: {
      title: '제품 구성 알아보기',
      desc: '혁신적인 위치추적 제품 구성을 확인 해 보세요.',
      outdoor: {
        title: '실외 카메라',
        desc: '카메라를 통하여 사람, 차량, 등 다양한 객체의<br/>위치 및 이상 행동을 감지하고 관리 할 수 있습니다.',
      },
      indoor: {
        title: '실내 카메라',
        desc: '카메라를 통하여 실내 사람들의<br/>이동경로를 분석 할 수 있습니다.',
      },
    },
  },

  banner: {
    title: '영상만으로 실시간 위치추적,<br/>사람과 차량의 움직임을 자동으로 추적합니다.',
    desc: 'AI Server와 AI Edge를 이용해, 사람·차량 등 객체 위치를<br/>간편하게 추적하고 ORBRO OS와 완벽히 연동해 보세요.',

    schemeTitle: '오브로가 제안하는 카메라 시스템.',
    schemeDesc: '결정하는데 도움이 필요하신가요? ',
    schemeDesc2: '로 연락 주시면<br/>출입 전문가가 도와드리도록 하겠습니다.',
    phone: '1522-9928',

    bgImg: cameraBannerBg,
    productImg: cameraBannerProduct,
  },

  bannerData: [
    {
      icon: IconEdgeOn,
      iconInv: IconEdgeAiInv,
      iconOff: IconEdgeOff,
      image: '',
      iconText: 'ORBRO Edge AI',
      sub: 'New',
      link: '/camera/edge',
    },
    {
      icon: IconServerOn,
      iconInv: IconAiServerInv,
      iconOff: IconServerOff,
      image: '',
      iconText: 'ORBRO AI Server',
      sub: 'New',
      link: '/camera/server',
    },
  ],

  screenView: {
    title: '실시간 영상이 연결되는 순간의 인사이트',
    data: [
      {
        icon: SvgGridLine,
        text: '다중 영상 스트리밍',
        img: screenViewCamera1,
      },
      {
        icon: SvgLocationLine,
        text: '위치정보 변환',
        img: screenViewCamera2,
      },
      {
        icon: SvgChartLine,
        text: '비디오 인사이트',
        img: screenViewCamera3,
      },
      {
        icon: SvgPencilLine,
        text: '프롬프트 기능 지원',
        img: screenViewCamera4,
      },
      {
        icon: SvgAi,
        text: '상황 인지 엔진',
        img: screenViewCamera5,
      },
    ],
  },

  screenShot: [
    {
      title: '태그 없이도, 영상만으로 위치 추적',
      desc: '사람과 차량이 카메라에 포착되면, 위치가 지도 위에 실시간 표시됩니다.<br/>별도의 태그 없이도 영상 기반으로 움직임을 인식하고, 도면 위에서 객체 위치를 시각적으로 확인할 수 있습니다.',
      img: {
        desktop: cameraScreenshot1D,
        tablet: cameraScreenshot1T,
        mobile: cameraScreenshot1M,
      },
    },
    {
      title: '새로 카메라를 설치하지 않아도 됩니다.',
      desc: 'RTSP, ONVIF 기반 CCTV라면 기존 영상 인프라만으로 AI 영상 위치추적을 시작할 수 있습니다.<br/>설정은 간단하고, 카메라 별 객체 인식 모델도 자유롭게 설정할 수 있습니다.',
      img: {
        desktop: cameraScreenshot2D,
        tablet: cameraScreenshot2T,
        mobile: cameraScreenshot2M,
      },
    },
    {
      title: 'AI가 공간 속 ‘행동’을 해석해 알려줍니다',
      desc: 'AI가 현장의 상황 자체를 이해하고 해석된 정보를 전달합니다.<br/>위험 상황을 감지하거나 작업 상태를 파악하고, 출입 감시까지 자동화하는 등 다양한 방식으로 활용할 수 있습니다.',
      img: {
        desktop: cameraScreenshot3D,
        tablet: cameraScreenshot3T,
        mobile: cameraScreenshot3M,
      },
    },
  ],

  video: {
    title: 'ORBRO 인공지능 카메라 시스템',
    desc: [
      { text: '야외 공간에 있는 차량과 사람의 위치 정보를 수집하고 분석합니다.' },
      { text: '실내 공간에서 이동하는 사람들의 위치 정보를 파악합니다.' },
      { text: '공용 CCTV와 같은 기존에 설치된 카메라 인프라와 연동이 가능합니다.' },
      { text: '필요한 카메라 장비를 손쉽게 추가하여 사용할 수 있습니다.' },
    ],
  },

  func: {
    title: '기능 더 알아보기',
    desc: '카메라의 다양한 기능을 확인해 보세요.',

    data: [
      {
        img: IconBlueShield,
        title: '권한 및 그룹 관리',
        desc: '관리자/사용자 권한을 구분하여 각 역할별 기능 접근을 제어할 수 있습니다.\n부서 또는 팀 단위의 그룹 구성도 가능합니다.',
      },
      {
        img: IconAlarm,
        title: '조건 알림 설정 (5단계)',
        desc: '지정 조건을 기준으로 총 5단계 등급의 알림을 설정할 수 있습니다.\n이상 징후를 빠르게 감지하고 대응할 수 있도록 도와줍니다.',
      },
      {
        img: Icon3dMeter,
        title: '구역 모니터링 (Zone)',
        desc: '지도 위에 Zone을 직접 설정하고, 해당 구역에 진입한 인원/자산을 실시간 모니터링할 수 있습니다.',
      },
      {
        img: Icon3dCycle,
        title: '역주행 감지',
        desc: '이동 경로의 방향성과 반대되는 움직임을 시스템이 자동 감지하여 경고를 발생시킵니다.',
      },
      {
        img: Icon3dDetect,
        title: '입출입 감지 (In/Out Zone)',
        desc: '출입 구역에 대한 입장과 퇴장을 자동으로 인식합니다.\n출입 기록과 체류 시간 분석도 가능합니다.',
      },
      {
        img: Icon3d3d,
        title: '기기 검색 및 상태 관리',
        desc: '수많은 Tag 및 Anchor 기기의 검색, 배터리 상태, 연결 상태 등을 한눈에 관리할 수 있습니다.',
      },
    ],
  },

  functions: {
    title: 'AI기술을 이용한 디지털트윈 위치추적 기술',
    desc: '오브로의 AI 카메라 시스템은 높은 정확도와 안정성을 자랑합니다.<br/>실내와 실외에서 사람과 차량의 위치를 파악하고 분석하여 사용자에게 필요한 데이터를 제공합니다.',

    line: 3,
    card: [
      {
        size: '3',
        tag: '핵심기능',
        title: '영상으로 감지된 물체가<br/>지도에서 실시간으로 표현',
        label: '관리자',
        img: {
          desktop: CameraFunctions1D,
          tablet: CameraFunctions1T,
          mobile: CameraFunctions1M,
        },
      },
      {
        color: '#fff',
        size: '1',
        tag: '모바일 서비스',
        title: '모든 공간,<br/>모바일 사용성 제공',
        label: '공통 제공',
        img: {
          desktop: CameraFunctions2D,
          tablet: CameraFunctions2T,
          mobile: CameraFunctions2M,
        },
      },
      {
        size: '2',
        tag: '기존 CCTV 호환',
        title: '모든 영상정보,<br/>모두 호환',
        label: '관리자',
        img: {
          desktop: CameraFunctions3D,
          tablet: CameraFunctions3T,
          mobile: CameraFunctions3M,
        },
      },
      {
        size: '2',
        tag: '사람, 차량 객체인식',
        title: '사람과 차량검출,<br/>높은 인식률',
        label: '관리자',
        img: {
          desktop: CameraFunctions4D,
          tablet: CameraFunctions4T,
          mobile: CameraFunctions4M,
        },
      },
      {
        size: '2',
        tag: '현장서버 구축',
        title: '가장 확실하고<br/>안정적인 보안체계',
        label: 'On-Premise',
        img: {
          desktop: CameraFunctions5D,
          tablet: CameraFunctions5T,
          mobile: CameraFunctions5M,
        },
      },
      {
        size: '1',
        tag: '야외 주차장 등 엔터프라이즈급 설치',
        title: '대규모 주차시설에도<br/>적용 가능한 설치',
        label: '엔터프라이즈',
        img: {
          desktop: CameraFunctions6D,
          tablet: CameraFunctions6T,
          mobile: CameraFunctions6M,
        },
      },
      {
        size: '3',
        tag: '대시보드',
        title: '데이터 인사이트,<br/>데이터 기반의 의사결정',
        label: '관리자',
        img: {
          desktop: CameraFunctions7D,
          tablet: CameraFunctions7T,
          mobile: CameraFunctions7M,
        },
      },
    ],
  },

  FAQ: [
    {
      title: 'ORBRO의 영상 위치추적 시스템은 어떤 방식으로 작동하나요?',
      description:
        '설치된 카메라에서 영상을 수집하고, AI가 영상 속 사람·차량 등을 실시간으로 인식하여 위치를 계산합니다.<br/>계산된 위치는 ORBRO OS를 통해 지도 위에서 시각화됩니다.',
    },
    {
      title: 'ORBRO Edge AI와 AI Server의 가장 큰 차이는 뭔가요?',
      description:
        'ORBRO Edge AI는 단일 장비에서 AI 분석과 위치 계산이 동시에 이루어지는 독립형 장치입니다.<br/>반면 AI Server는 여러 카메라의 영상을 통합 분석하며, ORBRO Server와 함께 운영되어야 합니다.',
    },
    {
      title: '기존에 설치된 CCTV와도 연동이 가능한가요?',
      description: '네. RTSP 또는 ONVIF 프로토콜을 지원하는 카메라라면 기존 CCTV와도 연동이 가능합니다.',
    },
    {
      title: '서버 없이도 사용할 수 있나요?',
      description: 'ORBRO Edge AI는 별도 서버 없이도 사용할 수 있습니다.<br/>단, AI Server는 ORBRO Server와 함께 운영되어야 합니다.',
    },
    {
      title: '영상 기반 위치추적이 BLE/UWB보다 좋은가요?',
      description:
        '상황에 따라 다릅니다.<br/>영상 기반은 별도 태그 없이도 동작하지만 시야각 제한이 있고,<br/>전파 기반은 시야가 없어도 작동하지만 태그가 필요합니다.<br/>ORBRO는 두 방식을 함께 사용할 수 있도록 지원합니다.',
    },
    {
      title: '영상 데이터는 저장되나요? 개인정보 이슈는 없나요?',
      description:
        '기본적으로 AI는 영상만 분석하고 데이터를 저장하지 않으며, 위치 정보만 서버에 남습니다.<br/>저장이 필요한 경우에도 암호화 및 접근 권한 설정이 가능합니다.',
    },
    {
      title: '분석 대상은 사람만 가능한가요?',
      description: '기본 대상은 사람이며, 옵션 설정에 따라 차량, 장비, 보호장비(예: 헬멧 착용 여부)도 분석이 가능합니다.',
    },
    {
      title: '실시간 알림도 받을 수 있나요?',
      description: '가능합니다.<br/>설정한 조건(ZONE 진입, 미검출 등)에 따라 관리자에게 실시간 알림(Push, Email, Webhook 등)을 전송할 수 있습니다.',
    },
  ],
};
